import { render } from "./About.html?vue&type=template&id=59cd6210&scoped=true&ts=true&external"
import script from "./About.ts?vue&type=script&lang=ts&external"
export * from "./About.ts?vue&type=script&lang=ts&external"

import "./About.css?vue&type=style&index=0&id=59cd6210&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cd6210"]])

export default __exports__